import React, { createContext, useState, useContext } from 'react';
import { getLocalStorageWithExpiry, setLocalStorageWithExpiry } from '../utils/storage';

const StoreValue = createContext();

export const useAuth = () => {
  return useContext(StoreValue);
};

// 2. Create the Provider Component
export const AuthProvider = ({ children }) => {
  // NEW STATE: For leadGuid and leadClient (from API response)
  const [leadGuid, setLeadGuidState] = useState(() => getLocalStorageWithExpiry('leadGuid'));
  const [agentIdVal, setAgentIdState] = useState(() => getLocalStorageWithExpiry('agentIdVal'));
  const [ContactGuid, setContactGuidState] = useState(() => getLocalStorageWithExpiry('ContactGuid'));
  // Persist loginInfo like the other session values. It is in-memory-only otherwise, and the
  // sidebar navigates with plain <a href> (a full page reload), so without this the DBA/phone/email
  // entered at login are lost whenever the merchant moves between steps — which blanks the ClientInfo
  // email prefill and disables the "reveal email" eye (whose only unmasked source is this value).
  const [loginInfo, setLoginInfoState] = useState(() => getLocalStorageWithExpiry('loginInfo') || { dba: '', phone: '', email: '' });
  // ISV template id from the merchant-app link (?ISV=<id>). Persisted because the ISV lead is no
  // longer cloned at login — the clone is deferred to the first ClientInfo save (so landing without
  // saving never creates an orphan lead), and the save needs this template id to clone from. The
  // login URL carries it but /ClientInfo does not, so it must survive the navigation.
  const [isvId, setIsvIdState] = useState(() => getLocalStorageWithExpiry('isvId'));


  // Function to update and store agentId
  const updateAgentId = (newAgentId) => {
    setAgentIdState(newAgentId);
    if (newAgentId) {
      setLocalStorageWithExpiry('agentIdVal', newAgentId);
    } else {
      localStorage.removeItem('agentIdVal'); // Clear if null
    }
  };

  // Function to update and store ContactGuid
  const updateContactGuid = (newContactGuid) => {
    setContactGuidState(newContactGuid);
    if (newContactGuid) {
      setLocalStorageWithExpiry('ContactGuid', newContactGuid);
    } else {
      localStorage.removeItem('ContactGuid'); // Clear if null
    }
  };

  const updateLoginInfo = (info) => {
    setLoginInfoState(info);
    if (info && (info.dba || info.phone || info.email)) {
      setLocalStorageWithExpiry('loginInfo', info);
    } else {
      localStorage.removeItem('loginInfo');
    }
  };

  // Set on the ISV login path, cleared on the non-ISV path, so a stale template id can never
  // trigger a deferred clone for a non-ISV merchant.
  const updateIsvId = (newIsvId) => {
    setIsvIdState(newIsvId);
    if (newIsvId) {
      setLocalStorageWithExpiry('isvId', newIsvId);
    } else {
      localStorage.removeItem('isvId');
    }
  };

  // new updater For leadGuid and leadClient
  const updateLeadGuid = (newGuid) => {
    setLeadGuidState(newGuid);
    if (newGuid) {
      setLocalStorageWithExpiry('leadGuid', newGuid);
    } else {
      localStorage.removeItem('leadGuid');
    }
  };


  // Provide all state values and updater functions to children
  return (
    <StoreValue.Provider value={{
      agentIdVal, ContactGuid, leadGuid, loginInfo, isvId, // All state values
      updateAgentId, updateContactGuid, updateLeadGuid, updateLoginInfo, updateIsvId // All updater functions
    }}>
      {children}
    </StoreValue.Provider>
  );
};

 export default StoreValue;